import React from 'react';
import Modal from './Modal';
import { refundAmount } from '../domain/team';

// Svincolo. La cifra mostrata usa la stessa funzione del server: prima client e
// server la calcolavano separatamente e con valori predefiniti opposti, quindi
// la modale poteva promettere un rimborso diverso da quello accreditato.

export default function ReleasePlayerModal({
    show,
    entry,
    player,
    quotazioniAvailable,
    onConfirm,
    onClose,
}) {
    if (!entry) return null;

    const inSerieA = player?.in_serie_a ?? null;
    const refund = refundAmount(entry.purchase_price, inSerieA);

    return (
        <Modal
            open={show}
            title="Svincola giocatore"
            onClose={onClose}
            footer={
                <>
                    <button type="button" className="btn btn--ghost" onClick={onClose}>
                        Annulla
                    </button>
                    <button type="button" className="btn btn--stop" onClick={onConfirm}>
                        Svincola
                    </button>
                </>
            }
        >
            <p>
                Vuoi svincolare <strong>{player?.['Nome Completo'] ?? `#${entry.player_id}`}</strong>,
                pagato {entry.purchase_price} crediti?
            </p>
            <p>
                Rimborso: <span className="badge badge--go">{refund}</span>
            </p>
            {inSerieA === false && (
                <p className="u-dim">Non risulta piu in Serie A: rimborso pieno.</p>
            )}
            {!quotazioniAvailable && (
                <p className="notice notice--warn">
                    La lista quotazioni non e caricata, quindi non e possibile sapere se il
                    giocatore sia ancora in Serie A: viene applicata la meta.
                </p>
            )}
        </Modal>
    );
}
